/**
 * 로어북 스캔 호스트 싱글턴(결정 #9/#12). 무거운 키워드 스캔을 Web Worker로
 * 오프로딩한다(작은 로어북은 동기, Worker 실패 시 동기 폴백 — 결과는 동일).
 */
import { LorebookScanHost } from "../platform/lorebook/scan-host.js";

export const scanHost = new LorebookScanHost();
